import Stack from "@mui/material/Stack";
import moment from "moment";
import { Link } from "react-router-dom";

import { PclProduct } from "features/public/Products/PCL/context/PclContextProvider";

const MaintenanceUpdateCell = ({
  row: { product_id, from_cc_portal: isInternational, active_maintenances },
}: {
  row: PclProduct;
}) => {
  return (
    <Stack spacing={"8px"}>
      {active_maintenances.map(({ completion_date, maintenance_id, title }) => {
        const displayDate = moment.utc(completion_date).format("YYYY.MM.DD");

        const domesticLink = `/products/${product_id}/assurancemaintenance/${maintenance_id}`;
        const internationalLink = `/products/international-product/${product_id}/assurancemaintenance/${maintenance_id}`;

        return (
          <span key={`${product_id}-${maintenance_id}`}>
            <strong>{displayDate}: </strong>
            <br />
            <Link
              to={isInternational ? internationalLink : domesticLink}
              className={isInternational ? "text-decoration-underline" : ""}
            >
              {title}
            </Link>
          </span>
        );
      })}
    </Stack>
  );
};

export default MaintenanceUpdateCell;
